import React from 'react';
import RadioButton from '../../../../../components/radioButton/RadioButton';
import CheckBox from '../../../../../components/checkBox/CheckBox';
import Button from '../../../../../components/Button/Button';

function Assistente({dati, onChange, onIndietro, onSalva, isModifica}) {

    function validateConferma() {
        return false
    }

    return (
        <div style={{marginTop: "30px"}}>

            <div style={{paddingBottom: "10px", borderBottom: "1px solid #dee2e6", marginBottom: "20px"}}>
                <h5 style={{fontWeight: "bold"}}>Assistente ricercato</h5>
            </div>

            <div className={"row"} style={{marginBottom: "20px"}}>
                <div className={"col-md-3"}>
                    <label style={{fontWeight: "bold", display: "block", marginBottom: "8px"}}>Sesso</label>
                    <RadioButton id={"sessoAssistente_M"} value={"M"} text={"Uomo"}
                        checked={dati.sessoAssistente === "M"}
                        onChange={(e) => onChange("sessoAssistente", e.target.value)}/>
                    <RadioButton id={"sessoAssistente_F"} value={"F"} text={"Donna"}
                        checked={dati.sessoAssistente === "F"}
                        onChange={(e) => onChange("sessoAssistente", e.target.value)}/>
                </div>
            </div>

            <div style={{marginBottom: "20px"}}>
                <label style={{fontWeight: "bold", display: "block", marginBottom: "8px"}}>Disponibilità oraria</label>
                <div className={"row"}>
                    <div className={"col-md-2"}><CheckBox id={"assistenzaDiurna"} text={"Assistenza diurna"} checked={!!dati.assistenzaDiurna} onChange={(e) => onChange("assistenzaDiurna", e.target.checked)}/></div>
                    <div className={"col-md-2"}><CheckBox id={"assistenzaNotturna"} text={"Assistenza notturna"} checked={!!dati.assistenzaNotturna} onChange={(e) => onChange("assistenzaNotturna", e.target.checked)}/></div>
                    <div className={"col-md-2"}><CheckBox id={"assistenzaFineSettimana"} text={"Fine settimana"} checked={!!dati.assistenzaFineSettimana} onChange={(e) => onChange("assistenzaFineSettimana", e.target.checked)}/></div>
                    <div className={"col-md-2"}><CheckBox id={"assistenzaChiamata"} text={"Ad ore"} checked={!!dati.assistenzaChiamata} onChange={(e) => onChange("assistenzaChiamata", e.target.checked)}/></div>
                    <div className={"col-md-2"}><CheckBox id={"h24"} text={"H24"} checked={!!dati.h24} onChange={(e) => onChange("h24", e.target.checked)}/></div>
                </div>
            </div>

            <div style={{marginBottom: "30px"}}>
                <label style={{fontWeight: "bold", display: "block", marginBottom: "8px"}}>Condizioni</label>
                <div className={"row"}>
                    <div className={"col-md-2"}><CheckBox id={"alloggio"} text={"Con alloggio"} checked={!!dati.alloggio} onChange={(e) => onChange("alloggio", e.target.checked)}/></div>
                    <div className={"col-md-2"}><CheckBox id={"vitto"} text={"Con vitto"} checked={!!dati.vitto} onChange={(e) => onChange("vitto", e.target.checked)}/></div>
                    <div className={"col-md-2"}><CheckBox id={"automunito"} text={"Automunito/a"} checked={!!dati.automunito} onChange={(e) => onChange("automunito", e.target.checked)}/></div>
                </div>
            </div>

            <div style={{display: "flex", gap: "10px", marginTop: "10px"}}>
                <Button typeButton={"White"} text={"Indietro"} onClick={onIndietro}
                    style={{height: "60px", width: "180px"}}/>
                <Button typeButton={"Blue"} text={isModifica ? "Salva modifiche" : "Salva"}
                    disabled={validateConferma()} onClick={onSalva}
                    style={{height: "60px", width: "200px"}}/>
            </div>
        </div>
    )
}

export default Assistente
